import React, { Component } from 'react';
import Snackbar from '@material-ui/core/Snackbar';
import SnackbarContent from '@material-ui/core/SnackbarContent';
import withStyles from '@material-ui/core/styles/withStyles';
import green from '@material-ui/core/colors/green';
import red from '@material-ui/core/colors/red';
import ErrorIcon from '@material-ui/icons/Error';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';
import PropTypes from 'prop-types';

const variantIcon = {
  success: CheckCircleIcon,
  error: ErrorIcon,
};

class Notification extends Component {


  render() {
    const message = this.props.message || this.props.errorMessage;
    // const bodyStyle = this.props.errorMessage
    // ? { backgroundColor: 'rgba(244, 67, 54, 0.9)' } : {};
    const className = this.props.errorMessage ? 'error' : 'success';
    const { classes } = this.props;
    const Icon = variantIcon[className];
    if (!message) return null;

    return (
      <Snackbar
        open={this.props.open}
        onClose={this.props.onCloseNotification}
        autoHideDuration={2000}
      >
        <SnackbarContent
          className={classes[className]}
          message={
            <div className={classes.messageContainer}>
              <Icon
                style={{ marginRight: 10 }}
                classes={{ icon: classes.icon, iconVariant: classes.iconVariant }}
              />
              {message}
            </div>
  }
          action={[
            <IconButton
              key="close"
              aria-label="Close"
              color="inherit"
              className={classes.close}
              onClick={this.props.onCloseNotification}
            >
              <CloseIcon className={classes.icon} />
            </IconButton>,
          ]}
        />


      </Snackbar>
    );
  }
}

Notification.propTypes = {
  open: PropTypes.bool.isRequired,
  classes: PropTypes.object,
  message: PropTypes.string,
  errorMessage: PropTypes.string,
  onCloseNotification: PropTypes.func.isRequired,
};

Notification.defaultProps = {
  message: null,
  errorMessage: null,
  classes: null,
};

const styles = () => ({
  success: {
    backgroundColor: '#4AB873',
  },
  error: {
    backgroundColor: '#EF4B4F',
  },
  icon: {
    fontSize: 20,
  },
  iconVariant: {
    opacity: 0.9,
    padding: 5,
  },
  messageContainer: {
    display: 'flex',
    alignItems: 'center',
  },
});

export default withStyles(styles)(Notification);


// WEBPACK FOOTER //
// ./src/app/main/notification/notification.js